var $ = require('jquery');

$(function () {
    function equalizeHeights() {
        var $selector = $('.navigation-cards__list__wrapper');
        $selector.css('height', '');
        // construct an array with all heights of selected elements
        var heights = $selector.map(function (i, e) {
            return $(e).innerHeight();
        });
        // apply max height to elements
        return $selector.innerHeight(
            Math.max.apply($(this), heights.get())
        );
    }

    equalizeHeights();

    $(window).on('resize', function () { // TO DO: throttle
        equalizeHeights();
    });
});